import { Location } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuController, ModalController } from '@ionic/angular';
import { startWith, Subject, takeUntil } from 'rxjs';

@Component({
	selector: 'app-main-header',
	templateUrl: './main-header.component.html',
	styleUrl: './main-header.component.scss',
})
export class MainHeaderComponent implements OnInit, OnDestroy {
	private readonly location = inject(Location);
	private readonly route = inject(ActivatedRoute);
	private readonly router = inject(Router);
	private readonly modalCtrl = inject(ModalController);
	public readonly menu = inject(MenuController);

	private unsubscribe$ = new Subject<void>();

	@Input() venueNumber: string;
	@Input() showBackBtn: boolean = false;
	@Input() bgSubLine: string;
	@Input() name!: string;

	backgroundColor: string;
	currentPath: string;

	goBack() {
		this.location.back();
	}
	close() {
		this.modalCtrl.dismiss();
	}

	ngOnInit(): void {
		this.currentPath = this.location.path();
		console.log('Current Path:', this.currentPath);
		this.route.queryParamMap.pipe(takeUntil(this.unsubscribe$), startWith(this.route.snapshot.queryParamMap)).subscribe(params => {
			this.name = params.get('name');
		});
	}

	ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	backToMenu() {
		this.name ? this.router.navigate(['/select-venue'], { queryParams: { name: this.name } }) : this.router.navigate(['/select-venue']);
	}
}
